import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import getThemeColor from "../../utils/getThemeColor"
import Avatar from "../Avatar"
import * as S from "./styled"

const Profile = () => {
  const {
    site: {
      siteMetadata: { title, author, position, description },
    },
  } = useStaticQuery(graphql`
    query HeaderQuery {
      site {
        siteMetadata {
          title
          author
          position
          description
        }
      }
    }
  `)

  return (
    <S.ProfileWrapper>
      <S.ProfileLink
        cover
        direction="left"
        bg={getThemeColor()}
        duration={0.6}
        to="/"
      >
        <Avatar />
        <S.ProfileItem>
          <S.ProfileTitle>{title}</S.ProfileTitle>
          <S.ProfileAuthor>{author.slice(0, 12)}</S.ProfileAuthor>
        </S.ProfileItem>
      </S.ProfileLink>
      <S.ProfileDivide>
        <S.ProfileEmail
          href="mailto:gabriel_jony@hotmail.com?subject=Assunto&body=Digite sua mensagem..."
          title="Enviar e-mail para Gabriel"
        >
          {author.slice(15)}
        </S.ProfileEmail>
        <S.ProfilePosition>{position}</S.ProfilePosition>
        <S.ProfileDescription>{description}</S.ProfileDescription>
      </S.ProfileDivide>
    </S.ProfileWrapper>
  )
}

export default Profile
